import { useContext, useEffect, useState } from 'react';
import { currentDateForFile, firstDayMonth, YMD_FORMAT } from '../../utils/DateUtils';
import { AppContext } from '../../contexts/AppContext';
import moment from 'moment';
import ActivityLogsAPI from '../../services/ActivityLogsAPI';
import { decodeFileXLSX } from '../../utils/MiscellaneousUtils';
import { SOURCETYPES } from "../../constants/GlobalConstants";

export const SORT = {
  UPWARD: 'upward',
  DOWNWARD: 'downward',
  NONE: '',
};

const useActivityLogsPresenter = tableRef => {
 
  const { showError, showWarning } = useContext(AppContext);
  const [firstLoad, setFirstLoad] = useState(true);
  const [loading, setLoading] = useState(false);
 
  const [activityType, setActivityType] = useState('Login/Logout');
  const [user, setUser] = useState('');
  const [exclusionActivity, setExclusionActivity] = useState('');

  const [rows, setRows] = useState([]);
  const [rowsToShow, setRowsToShow] = useState([]);
  const [sort, setSort] = useState('');
  const [oldSearchRequest, setOldSearchRequest] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [loadingExport, setLoadingExport] = useState(false);
  const [open, setOpen] = useState(false);
  const [dateFrom, setDateFrom] = useState(firstDayMonth());
  const [dateTo, setDateTo] = useState(moment());


  useEffect(() => {
    search();
  }, []);

  useEffect(() => {
    setRowsToShow(rows);
    
  }, [rows]);

  const cleanFilters = () => {
    setDateFrom(null);
    setDateTo(null);
    setActivityType('Login/Logout');
    setUser('');

  };

  const search = reload => {
    const request = reload
      ? oldSearchRequest
      : {
          
          startDate: dateFrom ? dateFrom.format(YMD_FORMAT) : undefined,
          endDate: dateTo ? dateTo.format(YMD_FORMAT) : undefined,
          activityType: activityType ? activityType : undefined,
          user: user ? user : undefined,
          sourceType: SOURCETYPES.ACTIVITY_LOGS,
          exclusionActivityType: 'Alta;Baja;Modificación'          
        };


    setOldSearchRequest(request);

    firstLoad && setFirstLoad(false);
    setLoading(true);
    setSelectedRows([]);

    ActivityLogsAPI.get(request)
      .then(res => setRows(res.data))
      .catch(error => showError('Error al obtener los registros'))
      .finally(() => setLoading(false));
  };

  const reloadGrid = () => search(true);

  
  const validateFilters = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = dateFrom && !dateTo)) {
      errorMessages.push('Debe completar el rango de fechas o quitar la Fecha desde');
    }

    if ((errors[i++] = !dateFrom && dateTo)) {
      errorMessages.push('Debe completar el rango de fechas o quitar la Fecha hasta');
    }

    if((errors[i++] = dateFrom && dateTo && dateTo.isBefore(dateFrom))){
      errorMessages.push('La Fecha hasta no puede ser menor a la Fecha desde');
    }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const validateAndSearch = () => validateFilters() && search();

  const handleExport = ids => {
    setLoadingExport(true);

    const request = ids ? ids : rows.map(r => r.id);

    return ActivityLogsAPI.exportToExcel(request)
      .then(res => decodeFileXLSX(res, `Actividades_Logueo_${currentDateForFile()}.xlsx`))
      .catch(error => showError('No se pudo descargar el archivo solicitado'))
      .finally(() => setLoadingExport(false));
  };

  return {

    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    activityType,
    setActivityType,
    user,
    setUser,
    validateAndSearch,
    cleanFilters,
    rows: rowsToShow,
    firstLoad,
    loading,
    gridFunctions: {
      disableSelectAll: 
      reloadGrid,
      selectedRows,
      setSelectedRows,
      open,
      setOpen,
      cuit: oldSearchRequest.cuit,
      gridActions: {
        handleExport,
        loadingExport,
        sort,
        setSort,       
      },
    },
  };
};

export default useActivityLogsPresenter;